import { ON_SELECT } from './listing-filters';
import CollapsibleBox from './collapsible-box';

export default class ConventionCategory extends HTMLElement {
  constructor() {
    super();
  }

  showHideCollapsibles(label?: string) {
    const children = this.querySelectorAll('collapsible-box');
    children.forEach(collapsible => {
      if (label) {
        const { thematics } = (collapsible as CollapsibleBox).dataset;
        const isConcerned = thematics && thematics.split(',').filter(theme => theme.trim())?.includes(label);

        collapsible.classList.toggle('hide', !isConcerned);
      } else {
        collapsible.classList.remove('hide');
      }
    });
  }

  init() {
    const filterComponent = this.querySelector('listing-filters');
    if (filterComponent) {
      filterComponent.addEventListener(ON_SELECT, (evt) => {
        this.showHideCollapsibles((evt as CustomEvent).detail['label']);
      });
    }
  }

  connectedCallback() {
    setTimeout(() => {
      this.init();
    });
  }
}